import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/config/rootReducer';

function useViewType() {
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { viewType } = useSelector((state: RootState) => state.investor);
    return viewType;
  } catch (err) {
    return 'achieved';
  }
}

export default useViewType;
